import { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import useErrorHandler from '../../../gqlCommon/hooks/useErrorHandler';
import trimLabel from '../../graphql/queries/trimLabel';
import { GetTrimLabel, GetTrimLabelVariables } from '../../graphql/queries/__generated__/GetTrimLabel';
import IParams from '../../../gqlCustomise/model/IParams';

const useTrimLabel = () => {
  const { trimCode } = useParams<IParams>();
  const [trimLabelData, setTrimLabelData] = useState<GetTrimLabel>();
  const { data, loading, error } = useQuery<GetTrimLabel, GetTrimLabelVariables>(trimLabel.GET_TRIM_LABEL, {
    variables: {
      trimCode,
    },
  });

  useEffect(() => {
    if (!loading && data) {
      setTrimLabelData(data);
    }
  });
  useErrorHandler(error);

  return { trimLabelData };
};

export default useTrimLabel;
